import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Form, Table } from "react-bootstrap";

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

import LoadingOverlay from '../components/LoadingOverlay'
import { SelectElement } from "../components/selectElement";
import { NoAcceso } from '../components/NoAcceso';


export const ModulosTipoAtencion = () => {

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const navigate = useNavigate();
    useEffect(() => {
        if(usuario.uidUsuario === null){
           navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])
    
    useHideMenu(false);
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [modulo, setModulo] = useState([]);
    const [ atencion, setAtencion ] = useState([]);
    const [ moduloSeleccionado, setModuloSeleccionado ] = useState('');
    
    
    
     // tabla
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const datos= useMemo(() =>{
        return {
            entidad,
            search : searchTerm || '',
            currentPage
        }
    }, [entidad, searchTerm, currentPage])
    

   
    useEffect(() => {
        
            socket.emit('select-Modulos', datos, ( lista ) => {
            console.log(lista)
               
                const opciones = lista.map( (item) => ( { value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` } ) )
                setModulo( opciones )
            })

          
        return () => {
            socket.off('select-Modulos')
        }
    }, [ socket, datos ])

    
    
    useEffect(() => {

        socket.on('ubicacion-tiposAtencion', ( lista ) => {
            setAtencion( lista )
        })

        return () => {
            socket.off('ubicacion-tiposAtencion')
        }


    }, [socket]);

   
    // **************************table

    useEffect(() => {

        // async function fetchAtenciones() {
            setIsLoading(true) 
            datos.uidModulo= moduloSeleccionado
            socket.emit('ubicacion-tiposAtencion', datos, ( lista ) => {
                setAtencion( lista )
                setIsLoading(false) 
            })
        // }

        // fetchAtenciones();


        return () => {
            socket.off('ubicacion-tiposAtencion')
        }


    }, [ socket, moduloSeleccionado, datos ]);

    const handleChecked = (checked, i) => {

        if (moduloSeleccionado === '' ) return false;

        let tmp = atencion[i];
        tmp.checked = !checked;
        // let atencionClone = [...atencion];
        // atencionClone[i] = tmp;
        // setAtencion([...atencionClone]);
        
        const data= {
            entidad,
            usuario: usuario.uidUsuario,
            uidTipoAtencion: atencion[i].uidTipoAtencion, 
            uidModulo: atencion[i].uidModulo, 
            checked: tmp.checked
        }
        setIsLoading(true) 
        socket.emit('edita-ubicacion-tipoAtencion', data, ( res ) => {
            console.log(res)
            setIsLoading(false) 

        })
        
    }

    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    if( usuario.uidUsuario === null ) {
        return(<></>)
    }
    else if( !pantallas.includes("tiposatencion") ) {
        return( <NoAcceso /> )
    } else{
        return (
            <>
            
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-5`} style={{minHeight:'100vh'}}>
                    {/* <div className='row mt-1' style={{ textAlign: "end" }}>
                        <div className='col-12  mt-1'>
                            <button className='btn btn-lg btn-danger rounded-pill  ' onClick={ () => salir()} >
                                <i className="fa-solid fa-arrow-right-from-bracket"></i>
                            </button>
                        </div>

                    </div>
                    
                    <div className='row '>
                    
                        <div className="mt-1 col-lg-4 col-12">
                            <img id="" style={{height:'auto', width:'100%'}} src={ imagenLogo } alt=''/>
                        </div>
                                            
                    </div>
                    
                    <hr /> */}

                    <div>

                    <div className='row'>
                
                        <div className='form-group col-lg-4 col-12 mb-3'>
                        
                            <Form.Label>Módulo</Form.Label>
                            <SelectElement
                                options= { modulo }
                                name={"modulo"}
                                isMulti= {false}
                                closeOnMenuSelect= {true}
                                onChange= {(ev) => setModuloSeleccionado( ev? ev.value : '' ) }
                                classname= "" 
                            />
                        </div>
                        
                        <div className='form-group col-lg-8 col-12 rounded shadow p-3'>
                        
                            <div className='row'>
                                <div className='col-12'>
                                    <div className=' float-end col-lg-4 col-12'>

                                        <input
                                            type='text'
                                            placeholder='Buscar...'
                                            className='form-control'
                                            defaultValue={searchTerm}
                                            onChange={ (ev) => handleSearch(ev)}
                                        />

                                    </div>
                                
                                </div>

                                <div className='col-12'>
                                    <Table responsive="sm" striped hover style={{minWidth: 400}} className='max400'>
                                        <thead>
                                            <tr>
                                                <th width={'5%'}></th>
                                                <th width={'95%'}>Tipo Atención</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {atencion.map((item, i) => (

                                                <tr key={item.uidTipoAtencion}>
                                                    <td width={'5%'}>
                                                
                                                        <div className="form-check form-switch">
                                                        {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                            <input 
                                                                className="form-check-input" 
                                                                checked= {item.checked } 
                                                                type="checkbox" 
                                                                id={`chkAsignado_${item.uidTipoAtencion}`} 
                                                                onChange={() => handleChecked(item.checked, i)  }
                                                                

                                                            
                                                            />

                                                            <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                                        </div>


                                                    </td>
                                                    <td width={'95%'}> 
                                                        {item.tipoAtencion.toUpperCase()}
                                                    </td>
                                                
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>

                            </div>

                            
                            
                        </div>
                    

                    </div>


                        
                                    
                    </div>
        
                    

                </div>    
            </>
        )
    }
}


// https://reactjsexample.com/react-multiselect-dropdown-with-search-and-various-options/